import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import IconPDF from '@mui/icons-material/PictureAsPdf';
import Directions from '@mui/icons-material/Directions';
import RightMenu from '../right_menu/RightMenu';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';

// Central list of protected route patterns
const protectedRoutePatterns = [
  /^\/plans/,
  /^\/plans_choice/,
  /^\/betrinfos/,
  /^\/umleitungen/,
  /^\/umleitungen_pager/,
  /^\/adm/,
  /^\/schul_meine_db/,
  /^\/bvh_app/,
  /^\/eco_app/,
  /^\/lap_id/,
  /^\/evi_app/,
  /^\/teams_app/,
  /^\/outlook_app/,
  /^\/stops_indicator/,
  /^\/bus_parking_game/,
];

export default function ButtonAppBar({ toggleDrawer, user }) {
  const location = useLocation();
  const navigate = useNavigate();
  const isProtected = protectedRoutePatterns.some(pattern => pattern.test(location.pathname));

  const handleNavigate = (path) => () => {
    navigate(path);
  };

  // State for right menu
  const [rightMenuAnchor, setRightMenuAnchor] = React.useState(null);

  // Role-based icons
  const roleIconMap = {
    admin:   <AdminPanelSettingsIcon sx={{ color: isProtected ? '#4caf50' : '#bbb', fontSize: 28 }} />,
    moderator: <SupervisorAccountIcon sx={{ color: isProtected ? '#4caf50' : '#bbb', fontSize: 28 }} />,
    user:    <CheckCircleIcon sx={{ color: isProtected ? '#4caf50' : '#bbb', fontSize: 28 }} />,
  };

  let icon;
  if (user) {
    const role = user.role?.toLowerCase();
    icon = roleIconMap[role] ||
      <CheckCircleIcon sx={{ color: isProtected ? '#4caf50' : '#bbb', fontSize: 28 }} />;
  } else {
    icon = <AccountCircleIcon sx={{ color: isProtected ? '#4caf50' : '#bbb', fontSize: 28, opacity: isProtected ? 1 : 0.7 }} />;
  }

  // Handler for user icon click
  const handleUserIconClick = (event) => {
    setRightMenuAnchor(event.currentTarget);
  };
  const handleRightMenuClose = () => {
    setRightMenuAnchor(null);
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
            onClick={toggleDrawer(true)}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Infogig.link
          </Typography>



<IconButton
            color="inherit"
            aria-label="home"
            onClick={handleNavigate("/home")}
            sx={{ ml: 1 }}
          >
            <IconPDF />
          </IconButton>


          <IconButton
            color="inherit"
            aria-label="umleitungen"
            onClick={handleNavigate("/umleitungen")}
            sx={{ ml: 1 }}
          >
            <Directions />
          </IconButton>

          <IconButton
            color="inherit"
            aria-label="umleitungen"
            onClick={handleNavigate("/user_manuals/bus_stop_trainning")}
            sx={{ ml: 1 }}
          >
            <DirectionsBusIcon />
          </IconButton>

          {/* User status icon as toggle for RightMenu */}
          <IconButton
            color="inherit"
            aria-label="user menu"
            onClick={handleUserIconClick}
            sx={{ ml: 1 }}
          >
            {icon}
          </IconButton>
          <RightMenu
            anchorEl={rightMenuAnchor}
            open={Boolean(rightMenuAnchor)}
            onClose={handleRightMenuClose}
          />
        </Toolbar>
      </AppBar>
    </Box>
  );
}
